import React, { useEffect, useState } from "react";
import TopBar from "../../Component/TopBar.tsx";
import Copyright from "../../Component/Copyright.tsx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faEye,
	faArchive,
	faCheck,
	faEdit,
	faTrash,
	faPlus,
	faFilter,
} from "@fortawesome/free-solid-svg-icons";

import Tabulator from "../../Component/Tabulator.tsx";
import "./SCSS/Appointment.scss";
import RequestHandler from "../../Functions/RequestHandler.js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ViewAppointmentModal from "../../Component/AppointmentModal.tsx";

const headers = [
	"ID",
	"Request ID",
	"Service Name",
	"Customer Email",
	"Start Date",
	"Created At",
	"Actions",
];

const renderRow = (item) => (
	<>
		<td>{item.id}</td>
		<td>{item.Request.id}</td>
		<td>{item.Request.Service.serviceName}</td>
		<td>{item.userEmail}</td>
		<td>{item.appointmentDate.split("T")[0]}</td>
		<td>{item.createdAt.split("T")[0]}</td>
	</>
);

export default function Appointment({ user, changeURL }) {
	const [requestData, setRequestData] = useState([]);
	const [currPage, setCurrPage] = useState(1);
	const [total, setTotal] = useState(0);
	const limit = 10;

	interface Service {
		uploadedDocument: string;
		uploadedDocuments: {
			fileName: string;
			url: string;
			isApproved: boolean;
		}[];
	}
	const [showServiceModal, setShowServiceModal] = useState(false);
	const [serviceData, setServiceData] = useState<Service | null>(null);

	const [showAppointmentModal, setShowAppointmentModal] = useState(false);
	const [appointmentDate, setAppointmentDate] = useState("");
	const [appointmentNotes, setAppointmentNotes] = useState("");

	const [showCompleteModal, setShowCompleteModal] = useState(false);
	const [certificateFile, setCertificateFile] = useState(null);
	const [completingRequestId, setCompletingRequestId] = useState(null);

	const actions = [
		{
			icon: faEye,
			className: "view-btn",
			label: "VIEW",
			onClick: (id, item) => viewServiceRequest(item.Request.id),
		},
		{
			icon: faEye,
			className: "done-btn",
			label: "VIEW NOTE",
			onClick: (id, item) => viewAppointment(item),
		},
		{
			icon: faCheck,
			className: "done-btn",
			label: "COMPLETE",
			onClick: (id, item) => completeRequest(item),
		},
	];

	const completeRequest = (item) => {
		setCompletingRequestId(item.requestId);
		setCertificateFile(null);
		setShowCompleteModal(true);
	};

	const submitCompletion = async (item) => {
		if (!certificateFile) {
			toast.error("Please upload a certificate!");
			return;
		}
		const toastId = toast.loading("Uploading certificate, please wait...");
		let uploadedUrl = "";
		try {
			const formData = new FormData();
			formData.append("file", certificateFile);
			try {
				const data = await RequestHandler.handleRequest(
					"post",
					"image/upload-image",
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);
				if (data.success) {
					uploadedUrl = data.uploadedDocument;
					console.log(`Certificate uploaded successfully: ${uploadedUrl}`);
				} else {
					toast.update(toastId, {
						render: `Failed to upload certificate: ${data.message}`,
						type: "error",
						isLoading: false,
						autoClose: 5000,
					});
					return null;
				}
			} catch (error) {
				console.error(`Error uploading certificate:`, error);
				toast.update(toastId, {
					render: `Error uploading certificate`,
					type: "error",
					isLoading: false,
					autoClose: 5000,
				});
				return null;
			}
			toast.update(toastId, {
				render: "Certificate uploaded successfully!",
				type: "success",
				isLoading: false,
				autoClose: 5000,
			});
		} catch (error) {
			console.error("Error processing the certificate file:", error);
			toast.update(toastId, {
				render: "Error processing the certificate file",
				type: "error",
				isLoading: false,
				autoClose: 5000,
			});
		} finally {
			setCertificateFile(null);
			setShowCompleteModal(false);
		}
		try {
			const data = await RequestHandler.handleRequest(
				"post",
				"request/completeRequest",
				{ id: completingRequestId, certificate: uploadedUrl }
			);
			if (!data.success) {
				toast.error(data.message || "Can't complete the request");
			} else {
				toast.success("Service completed successfully!");
			}
		} catch (error) {
			toast.error(`An error occurred while logging in. ${error}`);
		}
	};

	const viewAppointment = async (item) => {
		setAppointmentDate(
			new Date(item.appointmentDate).toISOString().split("T")[0]
		);
		setAppointmentNotes(item.appointmentNotes);
		setShowAppointmentModal(true);
	};

	const loadAllAppointment = async () => {
		try {
			const data = await RequestHandler.handleRequest(
				"post",
				"appointment/get_appointments",
				{ staffId: user.id, currPage, limit }
			);
			if (data.success === false) {
				toast.error(
					data.message ||
						"Error occurred. Please check your credentials."
				);
			} else {
				setRequestData(data.data);
				setTotal(data.total);
			}
		} catch (error) {
			toast.error(`An error occurred while requesting data. ${error}`);
		}
	};

	const viewServiceRequest = async (id) => {
		try {
			const data = await RequestHandler.handleRequest(
				"post",
				"request/view_service",
				{ id }
			);
			if (data.success === false) {
				toast.error(
					data.message ||
						"Error occurred. Please check your credentials."
				);
			} else {
				setServiceData(data.data);
				setShowServiceModal(true);
			}
		} catch (error) {
			toast.error(`An error occurred while requesting data. ${error}`);
		}
	};

	useEffect(() => {
		loadAllAppointment();
	}, [currPage]);

	return (
		<div className="appointment">
			<TopBar clickHandler={() => changeURL("profile")} />
			<div className="main-appointment">
				<div className="title">All Appointment</div>
				<Tabulator
					data={requestData}
					headers={headers}
					renderRow={renderRow}
					actions={actions}
					buttons={[]}
					selects={[]}
					currentPage={currPage}
					setCurrentPage={setCurrPage}
					itemsPerPage={limit}
					total={total}
					searchableHeaders={["id", "appointmentPeople"]}
				/>
			</div>
			{showServiceModal && serviceData && (
				<div className="serviceModal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
					<div className="modal-content bg-white rounded-lg shadow-lg overflow-hidden min-w-[50vw] w-full min-h-[80vh] max-h-[80vh] p-6">
						<div className="flex justify-between items-center border-b border-gray-200 pb-4 mb-4">
							<h2 className="text-xl font-semibold border-l-4 border-green-600 pl-4">
								Uploaded Documents
							</h2>
							<span
								className="text-5xl text-gray-200 cursor-pointer hover:text-red-500"
								onClick={() => setShowServiceModal(false)}
							>
								&times;
							</span>
						</div>

						<div className="overflow-y-auto">
							<table className="table-auto w-full border-collapse border border-gray-200 rounded-lg">
								<thead>
									<tr className="bg-green-100">
										<th className="border border-gray-200 px-4 py-2 text-left text-gray-800 font-semibold">
											File Name
										</th>
										<th className="border border-gray-200 px-4 py-2 text-gray-800 font-semibold">
											Actions
										</th>
									</tr>
								</thead>
								<tbody>
									{serviceData.uploadedDocuments.map(
										(document, index) => (
											<tr
												key={index}
												className="hover:bg-gray-50 transition-all duration-200"
											>
												<td className="border border-gray-200 px-4 py-2 text-gray-700">
													{document.fileName}
												</td>
												<td className="border border-gray-200 px-4 py-2 text-center space-x-4">
													{!document.isApproved ? (
														<button className="approve-btn bg-gray-400 text-white px-3 py-1 rounded-md cursor-not-allowed">
															NOT APPROVE
														</button>
													) : (
														<button
															className="approved-btn bg-gray-400 text-white px-3 py-1 rounded-md cursor-not-allowed"
															disabled
														>
															APPROVED
														</button>
													)}
													<a
														href={document.url}
														download={
															document.fileName
														}
														className="download-btn bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-md"
													>
														DOWNLOAD
													</a>
												</td>
											</tr>
										)
									)}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			)}
			{showAppointmentModal && (
				<ViewAppointmentModal
					onClose={() => setShowAppointmentModal(false)}
					appointmentDate={appointmentDate}
					appointmentNotes={appointmentNotes}
				/>
			)}
			{showCompleteModal && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
					<div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
						<div className="flex justify-between items-center mb-4">
							<h2 className="text-xl font-semibold">
								Complete Request
							</h2>
							<span
								className="text-3xl cursor-pointer text-gray-400 hover:text-red-500"
								onClick={() => setShowCompleteModal(false)}
							>
								&times;
							</span>
						</div>
						<div>
							<label className="block mb-2 text-sm font-medium text-gray-700">
								Upload Certificate PDF
							</label>
							<input
								type="file"
								accept="application/pdf"
								onChange={(e: any) => {
									const file = e.target.files[0];
									if (
										file &&
										file.type === "application/pdf"
									) {
										setCertificateFile(file);
									} else {
										toast.error(
											"Only PDF files are allowed."
										);
										e.target.value = null;
										setCertificateFile(null);
									}
								}}
								className="w-full border rounded px-3 py-2"
							/>
						</div>
						<div className="flex justify-end mt-4 space-x-2">
							<button
								onClick={() => setShowCompleteModal(false)}
								className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
							>
								Cancel
							</button>
							<button
								onClick={submitCompletion}
								className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
							>
								Complete Request
							</button>
						</div>
					</div>
				</div>
			)}

			<Copyright />
		</div>
	);
}
